import {
  COMPRESSED_LAYOUT_MAX_WIDTH_PX,
  LAYOUT_COMPRESSED,
} from '../../../../reducers/UiSettingsReducers';

/** How wide the agency dashboard's header box may grow, and whether it centres in the row. */
export interface AgencyHeaderWidth {
  readonly maxWidth: number | '100%';
  readonly margin: '0' | '0 auto';
}

/**
 * The compressed layout caps the agency dashboard's header and centres it, so it lines up with the capped page below.
 * With the broker experience on the page has a rail down its side and the header spans the row like the other
 * personas' header does: no cap, and the logo and Ask Moo sit at the two edges.
 */
export function agencyHeaderWidth({
  layout,
  fullWidth,
}: Readonly<{ layout: string; fullWidth: boolean }>): AgencyHeaderWidth {
  if (!fullWidth && layout === LAYOUT_COMPRESSED) {
    return { maxWidth: COMPRESSED_LAYOUT_MAX_WIDTH_PX, margin: '0 auto' };
  }
  return { maxWidth: '100%', margin: fullWidth ? '0' : '0 auto' };
}
